import axios, { getAuthHeaders } from './config'

export default {
    store: function(roles) {
        return axios.post('/roles', roles, {
            headers: getAuthHeaders()
        })
    },

    all: function() {
        return axios.get('/roles', {
            headers: getAuthHeaders()
        })
    },
    delete: function(roleId) {
        return axios.delete(`/roles/${roleId}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.put(`/roles/${data.roleId}`, data, {
            headers: getAuthHeaders()
        })
    },
    show: function(roleID) {
        return axios.get(`/roles/${roleID}`, {
            headers: getAuthHeaders()
        })
    },
}